/**
 * "What the AI is told" (SA-459 §6.2): an ai executor's instruction, its
 * threshold sentence and the labels of its inputs. Drawn by the step drawer's
 * section and, since SA-1078, by the task page's closed disclosure — one
 * markup, so the two never disagree. Pure over `StepDetailVM['ai']`.
 */
import type { StepDetailVM } from '@/utils/workflowOverview'
import { thresholdText } from './stepDrawerText'

export type AiToldVM = NonNullable<StepDetailVM['ai']>

export function AiTold({ ai }: { ai: AiToldVM }) {
  return (
    <div className="space-y-2">
      <pre className="whitespace-pre-wrap rounded-md bg-muted px-3 py-2.5 font-sans text-[13px] leading-normal text-foreground/80">{ai.instruction}</pre>
      <p className="text-xs text-foreground/80">
        Below {thresholdText(ai.threshold)} the person decides{ai.attachments ? ' · reads attachments' : ''}
      </p>
      {ai.inputs.length > 0 && (
        <span className="flex flex-wrap gap-1">
          {ai.inputs.map((label, i) => (
            <span key={`${i}:${label}`} title={label}
              className="inline-flex max-w-full items-center gap-1 whitespace-nowrap rounded-md border border-primary/20 bg-primary/10 px-1.5 text-[11px] font-medium leading-5">
              <span className="truncate">{label}</span>
            </span>
          ))}
        </span>
      )}
    </div>
  )
}
